import { InitialStateType, initialState } from "./context";
import { Actions } from "./types";
export enum payloadTypes {
  SET_USER = "SET_USER",
  SET_CLAIMS = "SET_CLAIMS",
  RESET = "RESET",
  SET_EDUATE_ID = "SET_EDUATE_ID",
  SET_EMPLOYEE_LOGIN_ID = "SET_EMPLOYEE_LOGIN_ID",
  SET_CUST_ID = "SET_CUST_ID",
  SET_EMP_ID = "SET_EMP_ID",
  SET_COMPANY_ID = "SET_COMPANY_ID",
  SET_SUB_ID = "SET_SUB_ID",
  SET_SUB_SITE_ID = "SET_SUB_SITE_ID",
  SET_CATEGORY_ID = "SET_CATEGORY_ID",
  SET_ITM_GROUP_ID = "SET_ITM_GROUP_ID",
  SET_MANUFACTURER_ID = "SET_MANUFACTURER_ID",
  SET_UOM_ID = "SET_UOM_ID",
  SET_ITEM_ID = "SET_ITEM_ID",
  SET_SUPPLIER_ID = "SET_SUPPLIER_ID",
  SET_LOCATION_ID = "SET_LOCATION_ID",
  SET_MRF_ID = "SET_MRF_ID",
  SET_MRFTRANS_ID = "SET_MRFTRANS_ID",
  SET_ACTIVE_FIN_YR = "SET_ACTIVE_FIN_YR",
  SET_EMAIL_CONFIG_ID = "SET_EMAIL_CONFIG_ID",
  SET_RFQ_ID = "SET_RFQ_ID",
  SET_RFQ_NO = "SET_RFQ_NO",
  SET_RFQTRNSUPPLY_ID = "SET_RFQTRNSUPPLY_ID",
  SET_ITEM_LEDGER_ID = "SET_ITEM_LEDGER_ID",
  SET_TICKET = "SET_TICKET",
  SET_JUNCTION_ID = "SET_JUNCTION_ID",
  EMP_SUB_TYPE = "EMP_SUB_TYPE",
  SET_ITEM_DETAILS_ID = "ITEM_DETAILS_ID",
  SET_PROJECT_ID = "SET_PROJECT_ID",
  SET_JUNCTION_TYPE = "SET_JUNCTION_TYPE",
  SET_GROUP_ID = "SET_GROUP_ID",
  SET_GRP_ASSEMBLY_ID = "SET_GRP_ASSEMBLY_ID",
  SET_LONGITUDE = "SET_LONGITUDE",
  SET_LATITUDE = "SET_LATITUDE",
  SET_TICKET_REASON_ID = "SET_TICKET_REASON_ID",
  SET_DEVICE_TYPE_ID = "SET_DEVICE_TYPE_ID",
  SET_PROJECT_EXT_ID = "SET_PROJECT_EXT_ID",
  SET_ITEMS_CHALLAN_ID = "SET_ITEMS_CHALLAN_ID",
}
export const reducer = (state: InitialStateType, action: Actions) => {
  switch (action.type) {
    case payloadTypes.SET_USER:
      return {
        ...state,
        user: action.payload.user,
      };
    case payloadTypes.SET_CLAIMS:
      return { ...state, claims: action.payload.claims };
    case payloadTypes.SET_CUST_ID:
      return { ...state, customerId: action.payload.customerId };
    // case payloadTypes.SET_AUTH_ID:
    //   return { ...state, authId: action.payload.authId };
    case payloadTypes.SET_EMP_ID:
      return { ...state, empId: action.payload.empId };
    case payloadTypes.SET_COMPANY_ID:
      return { ...state, companyId: action.payload.companyId };
    case payloadTypes.SET_SUB_ID:
      return { ...state, subsidiaryId: action.payload.subsidiaryId };
    case payloadTypes.SET_SUB_SITE_ID:
      return { ...state, subSiteId: action.payload.subSiteId };
    case payloadTypes.SET_CATEGORY_ID:
      return { ...state, categoryId: action.payload.categoryId };
    case payloadTypes.SET_ITM_GROUP_ID:
      return { ...state, itmGroupId: action.payload.itmGroupId };
    case payloadTypes.SET_ITEM_ID:
      return {
        ...state,
        itmId: action.payload.itmId,
        itmDesc: action.payload.itmDesc,
      };
    case payloadTypes.SET_MANUFACTURER_ID:
      return { ...state, manufacturerId: action.payload.manufacturerId };
    case payloadTypes.SET_SUPPLIER_ID:
      return { ...state, supplierId: action.payload.supplierId };
    case payloadTypes.SET_LOCATION_ID:
      return { ...state, locationId: action.payload.locationId };
    case payloadTypes.SET_UOM_ID:
      return { ...state, uomId: action.payload.uomId };
    case payloadTypes.SET_EDUATE_ID:
      return { ...state, eduateId: action.payload.eduateId };
    case payloadTypes.SET_MRF_ID:
      return { ...state, mrfId: action.payload.mrfId };
    case payloadTypes.SET_ACTIVE_FIN_YR:
      return { ...state, ActiveFinYr: action.payload.ActiveFinYr };
    case payloadTypes.SET_MRFTRANS_ID:
      return { ...state, mrfTransId: action.payload.mrfTransId };
    case payloadTypes.SET_EMAIL_CONFIG_ID:
      return { ...state, emailConfigId: action.payload.emailConfigId };
    case payloadTypes.SET_RFQ_ID:
      return { ...state, rfqId: action.payload.rfqId };
    case payloadTypes.SET_RFQ_NO:
      return { ...state, rfqNo: action.payload.rfqNo };
    case payloadTypes.SET_RFQTRNSUPPLY_ID:
      return { ...state, rfqTrnSupplyId: action.payload.rfqTrnSupplyId };
    case payloadTypes.SET_ITEM_LEDGER_ID:
      return { ...state, itemLedgerId: action.payload.itemLedgerId };
    case payloadTypes.SET_EMPLOYEE_LOGIN_ID:
      return { ...state, empLoginId: action.payload.empLoginId };
    case payloadTypes.SET_TICKET:
      return { ...state, ticketId: action.payload.ticketId };
    case payloadTypes.SET_JUNCTION_ID:
      return { ...state, junctionID: action.payload.junctionID };
    case payloadTypes.SET_JUNCTION_TYPE:
      return { ...state, junctionType: action.payload.junctionType };
    case payloadTypes.EMP_SUB_TYPE:
      return { ...state, empSubType: action.payload.empSubType };
    case payloadTypes.SET_ITEM_DETAILS_ID:
      return { ...state, itemDetailsId: action.payload.itemDetailsId };
    case payloadTypes.SET_PROJECT_ID:
      return { ...state, projectId: action.payload.projectId };
    case payloadTypes.SET_GRP_ASSEMBLY_ID:
      return { ...state, grpAssemblyId: action.payload.grpAssemblyId };

    case payloadTypes.RESET:
      return {
        ...initialState,
        empLoginId: state.empLoginId,
        claims: state.claims,
        user: state.user,
        ActiveFinYr: state.ActiveFinYr,
      };
    case payloadTypes.SET_GROUP_ID:
      return { ...state, groupId: action.payload.groupId };
    case payloadTypes.SET_LONGITUDE:
      return { ...state, longitude: action.payload.longitude };
    case payloadTypes.SET_LATITUDE:
      return { ...state, latitude: action.payload.latitude };
    case payloadTypes.SET_TICKET_REASON_ID:
      return { ...state, ticketReasonId: action.payload.ticketReasonId };
    case payloadTypes.SET_DEVICE_TYPE_ID:
      return { ...state, deviceTypeID: action.payload.deviceTypeID };
    case payloadTypes.SET_PROJECT_EXT_ID:
      return { ...state, projectExtId: action.payload.projectExtId };
    case payloadTypes.SET_ITEMS_CHALLAN_ID:
      return { ...state, ItmsChallanId: action.payload.ItmsChallanId };
    default:
      return state;
  }
};
